import React from "react";
import { useNavigate } from "react-router-dom";

import { useTheme } from "@bps/fluent-ui";

import { routes } from "../../common/routes/routes";
import { NavBarBase } from "../../layout/nav-bar/components/NavBarBase";
import { NavBarLogo } from "../../layout/nav-bar/components/NavBarLogo";
import { NavBarNavItem } from "../../layout/nav-bar/components/NavbarNavItem";

export const MobileNavBar = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <NavBarBase
      headerProps={{
        ...routes.bpMobileDashboard.basePath,
        logoProps: {
          text: undefined,
          onRenderLogo: logoProps => (
            <NavBarLogo
              red
              {...logoProps}
              onClick={() => {
                navigate(routes.bpMobile.path);
              }}
            />
          )
        },
        styles: {
          root: {
            ".ms-Icon": { color: theme.palette.themeLight }
          }
        }
      }}
      centerNavButtons={
        <>
          <NavBarNavItem
            collapse
            {...routes.bpMobileBooking.appointments}
            to={routes.bpMobileBooking.appointments.path}
            iconName="Calendar"
            pathMatch
          />
          <NavBarNavItem
            collapse
            {...routes.bpMobileTodo.userInbox}
            to={routes.bpMobileTodo.userInbox.path}
            iconName="Mail"
            pathMatch
          />

          <NavBarNavItem
            collapse
            {...routes.bpMobileAddressBook.patients}
            to={routes.bpMobileAddressBook.patients.path}
            iconName="search"
            pathMatch
          />
        </>
      }
    />
  );
};
